import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MmuMainMenuMainEntry } from '../../../main-menu';


export type MmuMenuDefinition = MmuMainMenuMainEntry[] | Observable<MmuMainMenuMainEntry[]>;
export const MMU_MENU_ITEMS = new InjectionToken<MmuMenuDefinition>('MMU_MENU_ITEMS', {
  providedIn: 'root',
  factory: (): MmuMainMenuMainEntry[] => []
});
